import { Button, Result } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';

interface Props {
  /** 缺少的权限码（可选，纯展示用，不参与判断） */
  required?: string[];
}

export default function NoPermissionPage({ required }: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Result
      status="403"
      title="无访问权限"
      subTitle={
        required?.length
          ? `当前页面需要权限：${required.join(' / ')}`
          : `当前账号无权访问 ${location.pathname}`
      }
      extra={
        <Button type="primary" onClick={() => navigate('/dashboard', { replace: true })}>
          返回概览
        </Button>
      }
    />
  );
}
